import { CaseStatus } from '@/@types/generated'
import format from '@/lib/format'
import { CaseStatusTextColor } from '@/lib/format/CaseStatus'
import { cn } from '@/lib/utils'

export default function CaseStatusBadge({ status }: { status: CaseStatus }) {
  return (
    <div className="flex items-center gap-0.5">
      <span
        className={cn(
          'relative h-4 text-4xl leading-3',
          CaseStatusTextColor[status]
        )}
      >
        &bull;
      </span>
      <span data-slot="status-text">{format.Enum(CaseStatus, status)}</span>
    </div>
  )
}
